(function () {
  "use strict";

  var CARD_SELECTOR = ".grid-product[data-product-id]";
  var IMPRESSION_RATIO = 0.5;
  var IMPRESSION_DWELL_MS = 500;
  var PDP_ENGAGED_MS = 10000;
  var impressionTimers = new WeakMap();
  var publishedImpressions = new Set();
  var cardObserver;

  function publish(name, data) {
    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== "function") {
      return;
    }
    try {
      var result = window.Shopify.analytics.publish(name, data);
      if (result && typeof result.catch === "function") result.catch(function () {});
    } catch (_error) {}
  }

  function sessionId() {
    var key = "alb_product_analytics_session";
    try {
      var existing = window.sessionStorage.getItem(key);
      if (existing) return existing;
      var generated =
        window.crypto && typeof window.crypto.randomUUID === "function"
          ? window.crypto.randomUUID()
          : "alb-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2);
      window.sessionStorage.setItem(key, generated);
      return generated;
    } catch (_error) {
      return "";
    }
  }

  function numberFromDataset(value) {
    if (value === undefined || value === null || value === "") return null;
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function currentListContext(card) {
    if (card.dataset.listContext) return card.dataset.listContext;
    var pathname = window.location.pathname;
    if (/^\/collections\//.test(pathname)) return "collection";
    if (/^\/search/.test(pathname)) return "search";
    if (/^\/products\//.test(pathname)) return "recommendation";
    if (pathname === "/") return "home";
    return "other";
  }

  function currentListId(card) {
    if (card.dataset.listId) return card.dataset.listId;
    var section = card.closest("[data-section-id], [id^='shopify-section-']");
    if (!section) return "";
    return section.dataset.sectionId || section.id.replace(/^shopify-section-/, "");
  }

  function listPosition(card) {
    if (card.dataset.listPosition) return Number(card.dataset.listPosition);
    var context = card.parentElement || document;
    var cards = Array.prototype.slice.call(context.querySelectorAll(CARD_SELECTOR));
    var index = cards.indexOf(card);
    return index >= 0 ? index + 1 : null;
  }

  function filterContext() {
    var filters = {};
    try {
      new URLSearchParams(window.location.search).forEach(function (value, key) {
        if (/^filter\./.test(key) || key === "sort_by") filters[key] = value;
      });
    } catch (_error) {}
    return filters;
  }

  function cardData(card) {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (_error) {
      params = { get: function () { return ""; } };
    }
    return {
      sessionId: sessionId(),
      productId: card.dataset.productId || "",
      variantId: card.dataset.productVariantId || "",
      productTitle: card.dataset.productTitle || "",
      productHandle: card.dataset.productHandle || "",
      priceAmount: numberFromDataset(card.dataset.productPrice),
      compareAtPriceAmount: numberFromDataset(card.dataset.productCompareAtPrice),
      currencyCode: card.dataset.currencyCode || "",
      listContext: currentListContext(card),
      listId: currentListId(card),
      listPosition: listPosition(card),
      searchQuery: params.get("q") || "",
      filterContext: filterContext()
    };
  }

  function impressionKey(data) {
    return [
      window.location.pathname,
      data.listId,
      data.listPosition,
      data.productId,
      data.variantId
    ].join("|");
  }

  function publishImpression(card) {
    var data = cardData(card);
    if (!data.productId) return;
    var key = impressionKey(data);
    if (publishedImpressions.has(key)) return;
    publishedImpressions.add(key);
    publish("product_card_impression", data);
  }

  function handleIntersection(entries) {
    entries.forEach(function (entry) {
      var card = entry.target;
      if (entry.isIntersecting && entry.intersectionRatio >= IMPRESSION_RATIO) {
        if (!impressionTimers.has(card)) {
          impressionTimers.set(
            card,
            window.setTimeout(function () {
              impressionTimers.delete(card);
              publishImpression(card);
            }, IMPRESSION_DWELL_MS)
          );
        }
      } else if (impressionTimers.has(card)) {
        window.clearTimeout(impressionTimers.get(card));
        impressionTimers.delete(card);
      }
    });
  }

  function observeCards(root) {
    if (!cardObserver) return;
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(CARD_SELECTOR).forEach(function (card) {
      if (card.dataset.albAnalyticsObserved === "true") return;
      card.dataset.albAnalyticsObserved = "true";
      cardObserver.observe(card);
    });
  }

  function startCardTracking() {
    if (!("IntersectionObserver" in window)) return;
    cardObserver = new IntersectionObserver(handleIntersection, {
      threshold: [IMPRESSION_RATIO]
    });
    observeCards(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(CARD_SELECTOR)) observeCards(node.parentElement);
          else observeCards(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener(
      "click",
      function (event) {
        var link = event.target.closest && event.target.closest(CARD_SELECTOR + " a");
        if (!link) return;
        var card = link.closest(CARD_SELECTOR);
        var data = cardData(card);
        if (data.productId) publish("product_card_clicked", data);
      },
      true
    );
  }

  function pdpData(root, engagementType) {
    return {
      sessionId: sessionId(),
      productId: root.dataset.productId || "",
      variantId: root.dataset.productVariantId || "",
      productTitle: root.dataset.productTitle || "",
      productHandle: root.dataset.productHandle || "",
      priceAmount: numberFromDataset(root.dataset.productPrice),
      compareAtPriceAmount: numberFromDataset(root.dataset.productCompareAtPrice),
      currencyCode: root.dataset.currencyCode || "",
      engagementType: engagementType
    };
  }

  function startPdpTracking() {
    if (!/^\/products\//.test(window.location.pathname)) return;
    var root = document.querySelector("[data-product-id][data-product-handle]");
    if (!root || !root.dataset.productId) return;
    var sent = new Set();
    function engaged(type) {
      if (sent.has(type)) return;
      sent.add(type);
      publish("pdp_engagement", pdpData(root, type));
    }

    window.setTimeout(function () {
      if (document.visibilityState === "visible") engaged("engaged_10_seconds");
    }, PDP_ENGAGED_MS);

    document.addEventListener(
      "click",
      function (event) {
        var target = event.target.closest && event.target.closest(
          ".js-photoswipe__zoom, [data-product-thumb], .wishlist-engine-button, [data-share-button], .authenticity-popup, .condn-popup"
        );
        if (!target) return;
        if (target.matches(".js-photoswipe__zoom, [data-product-thumb]")) engaged("image_interaction");
        else if (target.matches(".wishlist-engine-button")) engaged("wishlist");
        else if (target.matches("[data-share-button]")) engaged("share");
        else if (target.matches(".authenticity-popup")) engaged("authentication_info");
        else if (target.matches(".condn-popup")) engaged("condition_info");
      },
      true
    );
  }

  function start() {
    startCardTracking();
    startPdpTracking();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
